<div class="clickable" (click)="onConfigurationClick()">
  <ng-content></ng-content>
</div>